export enum ErrorType {
  NETWORK = 'NetworkError',
  API = 'APIError',
  CLIENT = 'ClientError',
  SERVER = 'ServerError',
  VALIDATION = 'ValidationError',
  AUTHENTICATION = 'AuthenticationError',
  AUTHORIZATION = 'AuthorizationError',
  NOT_FOUND = 'NotFoundError',
  UNKNOWN = 'UnknownError',
}

export function classifyError(statusCode?: number): ErrorType {
  if (statusCode === 0) return ErrorType.NETWORK;
  if (statusCode === 401) return ErrorType.AUTHENTICATION;
  if (statusCode === 403) return ErrorType.AUTHORIZATION;
  if (statusCode === 404) return ErrorType.NOT_FOUND;
  if (statusCode && statusCode >= 400 && statusCode < 500) return ErrorType.CLIENT;
  if (statusCode && statusCode >= 500) return ErrorType.SERVER;
  return ErrorType.UNKNOWN;
}

export function shouldReportError(statusCode?: number): boolean {
  if (statusCode === 401 || statusCode === 403 || statusCode === 404) return false;
  return true;
}

export function formatErrorForUser(statusCode?: number, referenceId?: string): string {
  if (statusCode === 401) return 'Your session has expired. Please log in again.';
  if (statusCode === 403) return "You don't have permission to perform this action.";
  if (statusCode === 404) return 'The requested resource was not found.';
  if (statusCode && statusCode >= 500) {
    return referenceId
      ? `A server error occurred. Reference ID: ${referenceId}`
      : 'A server error occurred. Please try again later.';
  }
  if (statusCode === 0)
    return 'Unable to connect to the server. Please check your internet connection.';
  return referenceId
    ? `An error occurred. Reference ID: ${referenceId}`
    : 'An error occurred. Please try again.';
}
